import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, vModelText as _vModelText, resolveDirective as _resolveDirective, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelSelect as _vModelSelect, createBlock as _createBlock, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "form-group" };
const _hoisted_2 = { class: "d-flex justify-content-around" };
const _hoisted_3 = ["onClick"];
const _hoisted_4 = {
    key: 0,
    class: "fs-14 my-2"
};
const _hoisted_5 = { class: "fs-22 text-green" };
const _hoisted_6 = {
    key: 1,
    class: "fs-14 my-2"
};
const _hoisted_7 = { class: "fs-22 text-green" };
const _hoisted_8 = { class: "form-group" };
const _hoisted_9 = { class: "form-group" };
const _hoisted_10 = { class: "form-group" };
const _hoisted_11 = { class: "row" };
const _hoisted_12 = { class: "form-group col-sm-6" };
const _hoisted_13 = { class: "form-group col-sm-6" };
const _hoisted_14 = { class: "form-group" };
const _hoisted_15 = ["value"];
const _hoisted_16 = { class: "row" };
const _hoisted_17 = { class: "col-sm-4 d-flex" };
const _hoisted_18 = { class: "form-group w-100" };
const _hoisted_19 = {
    key: 0,
    class: "form-group w-100"
};
const _hoisted_20 = {
    key: 1,
    class: "form-group w-100"
};
const _hoisted_21 = { class: "form-group col-sm-1" };
const _hoisted_22 = { class: "form-group col-sm-1" };
const _hoisted_23 = { class: "form-group col-sm-3" };
const _hoisted_24 = { class: "d-flex align-items-center" };
const _hoisted_25 = ["value"];
const _hoisted_26 = ["href"];
const _hoisted_27 = {
    key: 0,
    class: "form-group col-sm-3"
};
const _hoisted_28 = { class: "text-right mt-2" };
const _hoisted_29 = {
    key: 1,
    class: "btn btn-blue",
    type: "submit"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_op_date = _resolveComponent("op-date");
    const _component_op_date_time = _resolveComponent("op-date-time");
    const _component_mini_spinner = _resolveComponent("mini-spinner");
    const _component_val_form = _resolveComponent("val-form");
    const _directive_required = _resolveDirective("required");
    const _directive_number = _resolveDirective("number");
    return (_ctx.task)
        ? (_openBlock(), _createBlock(_component_val_form, {
            key: 0,
            onSubmit: _ctx.next,
            onInvalid: _ctx.warn
        }, {
            default: _withCtx(() => [
                _cache[33] || (_cache[33] = _createElementVNode("h4", null, "Dati task", -1)),
                _createElementVNode("div", _hoisted_1, [
                    _cache[16] || (_cache[16] = _createElementVNode("label", null, "Prodotto (scala il credito)", -1)),
                    _createElementVNode("div", _hoisted_2, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.products, (item, i) => {
                            return (_openBlock(), _createElementBlock("button", {
                                type: "button",
                                class: _normalizeClass(["btn btn-white", { active: _ctx.task.product.identifier == item.identifier }]),
                                key: i,
                                onClick: ($event) => (_ctx.setTaskProduct(item))
                            }, _toDisplayString(item.name), 11, _hoisted_3));
                        }), 128))
                    ]),
                    (_ctx.task.postOrderTask)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                            _cache[14] || (_cache[14] = _createTextVNode("Il cliente ha acquistato anche: ")),
                            _createElementVNode("b", _hoisted_5, _toDisplayString(_ctx.task.postOrderTask.name), 1)
                        ]))
                        : _createCommentVNode("", true),
                    (_ctx.task.deliveryOption)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            _cache[15] || (_cache[15] = _createTextVNode("Opzione di consegna: ")),
                            _createElementVNode("b", _hoisted_7, _toDisplayString(_ctx.task.deliveryOption.title), 1)
                        ]))
                        : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_8, [
                    _cache[17] || (_cache[17] = _createElementVNode("label", null, "Valore in crediti", -1)),
                    _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.task.creditPrice) = $event)),
                        onInput: _cache[1] || (_cache[1] =
                            //@ts-ignore
                            (...args) => (_ctx.calcCompenso && _ctx.calcCompenso(...args)))
                    }, null, 544), [
                        [_vModelText, _ctx.task.creditPrice],
                        [_directive_required, _ctx.task.creditPrice],
                        [_directive_number, _ctx.task.creditPrice]
                    ])
                ]),
                _createElementVNode("div", _hoisted_9, [
                    _cache[18] || (_cache[18] = _createElementVNode("label", null, "Nome task (es. indirizzo, tipo appartamento)", -1)),
                    _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.task.title) = $event))
                    }, null, 512), [
                        [_vModelText, _ctx.task.title],
                        [_directive_required, _ctx.task.title]
                    ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                    _cache[19] || (_cache[19] = _createElementVNode("label", null, "Descrizione e note", -1)),
                    _withDirectives(_createElementVNode("textarea", {
                        class: "form-control",
                        rows: "3",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.task.description) = $event))
                    }, null, 512), [
                        [_vModelText, _ctx.task.description],
                        [_directive_required, _ctx.task.description]
                    ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                        _cache[20] || (_cache[20] = _createElementVNode("label", null, "Data inizio", -1)),
                        _createVNode(_component_op_date, {
                            class: "form-control",
                            modelValue: _ctx.task.startDate,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.task.startDate) = $event))
                        }, null, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                        _cache[21] || (_cache[21] = _createElementVNode("label", null, "Data consegna", -1)),
                        _createVNode(_component_op_date_time, {
                            class: "form-control",
                            modelValue: _ctx.task.dueDate,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.task.dueDate) = $event))
                        }, null, 8, ["modelValue"])
                    ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                    _cache[23] || (_cache[23] = _createElementVNode("label", null, "Gestito da", -1)),
                    _withDirectives(_createElementVNode("select", {
                        class: "form-control",
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.task.officeIdentifier) = $event))
                    }, [
                        _cache[22] || (_cache[22] = _createElementVNode("option", { value: null }, "Nessuno", -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.offices, (item, i) => {
                            return (_openBlock(), _createElementBlock("option", {
                                value: item.identifier,
                                key: i
                            }, _toDisplayString(item.name), 9, _hoisted_15));
                        }), 128))
                    ], 512), [
                        [_vModelSelect, _ctx.task.officeIdentifier]
                    ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                            _cache[24] || (_cache[24] = _createElementVNode("label", null, "Compenso", -1)),
                            _withDirectives(_createElementVNode("input", {
                                type: "text",
                                class: "form-control",
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_ctx.task.compenso) = $event))
                            }, null, 512), [
                                [_vModelText, _ctx.task.compenso],
                                [_directive_required, _ctx.task.compenso],
                                [_directive_number, _ctx.task.compenso]
                            ])
                        ]),
                        (_ctx.task.qualitaTask.hasExtraCompenso)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                _cache[25] || (_cache[25] = _createElementVNode("label", null, "Compenso Extra", -1)),
                                _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    readonly: "",
                                    class: "form-control border-0",
                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_ctx.task.qualitaTask.extraCompensoAmount) = $event))
                                }, null, 512), [
                                    [_vModelText, _ctx.task.qualitaTask.extraCompensoAmount]
                                ])
                            ]))
                            : _createCommentVNode("", true),
                        (_ctx.task.deliveryOption && _ctx.task.deliveryOption.commissionForAgent)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                _cache[26] || (_cache[26] = _createElementVNode("label", null, "Compenso delivery", -1)),
                                _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    readonly: "",
                                    class: "form-control border-0",
                                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_ctx.task.deliveryOption.commissionForAgent) = $event))
                                }, null, 512), [
                                    [_vModelText, _ctx.task.deliveryOption.commissionForAgent]
                                ])
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                        _cache[27] || (_cache[27] = _createElementVNode("label", null, "Priorità", -1)),
                        _createElementVNode("div", null, [
                            _createElementVNode("button", {
                                type: "button",
                                class: _normalizeClass(["btn btn-checkbox", { 'checked': _ctx.task.priorita }]),
                                onClick: _cache[10] || (_cache[10] = ($event) => (_ctx.task.priorita = !_ctx.task.priorita))
                            }, null, 2)
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                        _cache[28] || (_cache[28] = _createElementVNode("label", null, "Deve seguire le foto", -1)),
                        _createElementVNode("div", null, [
                            _createElementVNode("button", {
                                type: "button",
                                class: _normalizeClass(["btn btn-checkbox", { 'checked': _ctx.task.deveSeguireLeFoto }]),
                                onClick: _cache[11] || (_cache[11] = ($event) => (_ctx.task.deveSeguireLeFoto = !_ctx.task.deveSeguireLeFoto))
                            }, null, 2)
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                        _cache[31] || (_cache[31] = _createElementVNode("label", null, "Assegna a:", -1)),
                        _createElementVNode("div", _hoisted_24, [
                            _withDirectives(_createElementVNode("select", {
                                class: "form-control",
                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((_ctx.userAssigned) = $event))
                            }, [
                                _cache[29] || (_cache[29] = _createElementVNode("option", { value: null }, "Nessuno", -1)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.collaboratori, (item, i) => {
                                    return (_openBlock(), _createElementBlock("option", {
                                        key: i,
                                        value: item
                                    }, _toDisplayString(item.name), 9, _hoisted_25));
                                }), 128))
                            ], 512), [
                                [_vModelSelect, _ctx.userAssigned]
                            ]),
                            (_ctx.userAssigned && _ctx.collaboratore && _ctx.whatsappLink)
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 0,
                                    href: _ctx.whatsappLink,
                                    target: "_blank",
                                    class: "btn btn-sm btn-green ml-2"
                                }, _cache[30] || (_cache[30] = [
                                    _createElementVNode("i", { class: "fab fa-whatsapp" }, null, -1)
                                ]), 8, _hoisted_26))
                                : _createCommentVNode("", true)
                        ])
                    ]),
                    (_ctx.userAssigned)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                            _cache[32] || (_cache[32] = _createElementVNode("label", null, "Data prima assegnazione", -1)),
                            _createVNode(_component_op_date, {
                                class: "form-control",
                                modelValue: _ctx.task.userAssigned.date,
                                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => ((_ctx.task.userAssigned.date) = $event))
                            }, null, 8, ["modelValue"])
                        ]))
                        : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_28, [
                    (_ctx.saving)
                        ? (_openBlock(), _createBlock(_component_mini_spinner, { key: 0 }))
                        : (_openBlock(), _createElementBlock("button", _hoisted_29, " Salva "))
                ])
            ]),
            _: 1
        }, 8, ["onSubmit", "onInvalid"]))
        : _createCommentVNode("", true);
}
